<div class="mt">
  <title
    direction="left"
    [style]="{
      'font-size': '16px',
      color: '#3376F6',
      'margin-bottom': '1.5rem',
    }"
  >
    Désignation du (des) bénéficiaires
  </title>

  <pr-input-radio
    formControlName="avClauseBeneficiaireStandard"
    [derrors]="derrors"
    direction="column"
    [isDefault]="false"
    [options]="options"
    columns="1"
    label="Bénéficiaire en cas de décès de l’Assuré :"
  >
  </pr-input-radio>
</div>
